import { Box, ButtonLink, Dialog, Flex, LargeText, Text } from "@shared/primitive-components"
import { useState } from "react"
import { isConnectivityTargetMet } from "../../utils"
import * as styles from "../styles/thresholdDialogStyles"
import { usePolicyAccessCapabilities } from "../../hooks/index"

export const CONNECT_YOUR_FLEET_MODAL_DTI = {
  MODAL: `connect_fleet_modal`,
  CLOSE_BUTTON: `connect_fleet_close_button`,
  CONNECT_VEHICLES_BUTTON: `connect_fleet_connect_vehicles_button`,
  ORDER_DEVICES_BUTTON: `connect_fleet_order_devices_button`,
  CONNECTED_VALUE: `connected-value`,
  DISCONNECTED_VALUE: `disconnected-value`,
}
export type ConnectivityThresholdDialogProps = {
  title: string
  connectedTotal: number
  disconnectedTotal: number
  isMatrixPolicy: boolean
}

export const ConnectivityThresholdDialog = ({
  title,
  connectedTotal,
  disconnectedTotal,
  isMatrixPolicy,
}: ConnectivityThresholdDialogProps) => {
  const [open, setOpen] = useState(!isConnectivityTargetMet(connectedTotal, disconnectedTotal))
  const { isRebateV2Policy } = usePolicyAccessCapabilities()

  return (
    <Dialog
      open={open}
      closeDialog={() => setOpen(false)}
      hideActions
      rootCss={styles.root}
      contentCss={styles.content}
      dataTestId={CONNECT_YOUR_FLEET_MODAL_DTI.MODAL}
      closeButtonDataTestId={CONNECT_YOUR_FLEET_MODAL_DTI.CLOSE_BUTTON}
    >
      <Flex>
        <Flex flexDirection="column" justifyContent="space-between" css={styles.left}>
          <Box>
            <Text use="body2" css={styles.pageTitle}>
              {title.toUpperCase()}
            </Text>
            <LargeText css={styles.title}>{`Connect \nyour fleet`}</LargeText>
            <Text css={styles.text}>
              {isRebateV2Policy
                ? `Ensure at least 75% of your fleet is connected to qualify for premium rebates and unlock safety insights.`
                : `Ensure at least 75% of your fleet is connected to grow premium rebates and unlock safety insights.`}
            </Text>
            <Text css={styles.text}>
              Keep your vehicles connected to comply with your policy requirements and optimise your fleet&apos;s
              safety. Failure to connect may result in policy cancellation.
            </Text>
          </Box>
          {isMatrixPolicy && (
            <ButtonLink
              css={styles.button}
              variant="brand"
              href="https://flockcover.typeform.com/to/eTJUxZJT"
              target="__blank"
              color="yellow"
              data-testid={CONNECT_YOUR_FLEET_MODAL_DTI.ORDER_DEVICES_BUTTON}
            >
              Order devices
            </ButtonLink>
          )}
          <ButtonLink
            css={styles.button}
            variant="brand"
            href="https://help.flockcover.com/how-do-i-fix-issues-connecting-my-telematics-data-to-flock"
            target="__blank"
            color="yellow"
            data-testid={CONNECT_YOUR_FLEET_MODAL_DTI.CONNECT_VEHICLES_BUTTON}
            id="connect-vehicles-connectivity-banner"
          >
            Connect vehicles
          </ButtonLink>
        </Flex>
        <Flex flexDirection="column" justifyContent="space-between" css={styles.right}>
          <Box css={styles.disconnected} data-testid={CONNECT_YOUR_FLEET_MODAL_DTI.DISCONNECTED_VALUE}>
            <LargeText>{disconnectedTotal}</LargeText>
            <Text css={styles.label}>Disconnected</Text>
          </Box>
          <Box css={styles.connected} data-testid={CONNECT_YOUR_FLEET_MODAL_DTI.CONNECTED_VALUE}>
            <LargeText>{connectedTotal}</LargeText>
            <Text css={styles.label}>Connected</Text>
          </Box>
        </Flex>
      </Flex>
    </Dialog>
  )
}
